// import thunkMiddleware from 'redux-thunk'
// import createLogger from 'redux-logger'
import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { persistStore, autoRehydrate } from 'redux-persist'
import Raven from 'raven-js'
import createRavenMiddleware from 'raven-for-redux'
import rootSaga from './saga'
import rootReducer from './reducer'
import { env } from '../helpers/parameters'

Raven.config('https://deb922b7c036654b74e5a54731616c2e@o123553.ingest.us.sentry.io/4507089990057984', {
  environment: env.stage,
  shouldSendCallback: () => import.meta.env.NODE_ENV !== 'development'
}).install()

export default function configureStore(initialState) {
  const sagaMiddleware = createSagaMiddleware({
    onError: (error) => Raven.captureException(error)
  })

  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(sagaMiddleware, createRavenMiddleware(Raven)),
      window.window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.window.__REDUX_DEVTOOLS_EXTENSION__()
        : (f) => f,
      autoRehydrate()
    )
  )

  sagaMiddleware.run(rootSaga)

  persistStore(store, { whitelist: ['feedback', 'callControl'] })

  return store
}
